<kendo-dialog-actions *ngIf="!!uploadFilesSettings.showTopButtons && filesToUpload?.length > 0" fxLayoutAlign="start start" fxLayoutGap="3px"
    class="k-actions k-actions-start">
    <button class="k-button k-clear-selected" kendoButton type="button" (click)="clearClick()">
        {{'kendo.upload.clearSelectedFiles' | translate}}
    </button>

    <button kendoButton class="k-button k-primary k-upload-selected" type="button" [disabled]="compressionOngoing" (click)="uploadClick()">
        {{'kendo.upload.uploadSelectedFiles' | translate}}
    </button>
</kendo-dialog-actions >

<div class="upload">
    <kendo-upload #uploadCtrl
    [id]="uploadControlId"
    [ngClass]="{ 'showTopButtons' : uploadFilesSettings.showTopButtons, 'uploadDisabled': compressionOngoing }"
    [autoUpload]="uploadFilesSettings.autoUpload" 
    [saveUrl]="uploadDocumentUrl" 
    (select)="onSelectEvent($event)"
    (remove)="onRemoveEvent($event)" 
    (upload)="onUploadEvent($event)" 
    (complete)="onCompleteEvent($event)" 
    [restrictions]="uploadFilesSettings.fileRestrictions" 
    [actionsLayout]="'start'"
    [showFileList]="true">
        <kendo-upload-messages [select]="uploadSelectText"></kendo-upload-messages>
    </kendo-upload>
</div>

<div kendoDialogContainer #uploadParamsDialog></div>